import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { productTypes } from '../../types/products';

import LineItemHeaderPF from '../LineItemHeaderPF';
import { Table } from '../../components';

import columns from './columns';
import forecastColumns from './forecastColumns';

export const OrderLineItemPF = ({
  product,
  product: { productCode, sizes },
  currencyCode,
  paymentMethod,
  baseClass,
  isForecast
}) => {
  for (let i = 0, l = sizes.length; i < l; i++) {
    Object.keys(sizes[i]).forEach(key => {
      // eslint-disable-next-line no-param-reassign
      if (sizes[i][key] === null) sizes[i][key] = 0;
    });
  }

  return (
    <div
      className={classnames(
        `${baseClass}__lineItem`,
        'border-light-grey mb1-sm p3-sm u-full-width flex-container column start'
      )}
    >
      <LineItemHeaderPF
        product={product}
        currencyCode={currencyCode}
        paymentMethod={paymentMethod}
        baseClass={baseClass}
      />
      <Table
        overrideClass='details__product_table mt4-sm '
        data={sizes}
        columns={!isForecast ? columns : forecastColumns}
        id={productCode}
      />
    </div>
  );
};

OrderLineItemPF.propTypes = {
  product: productTypes.isRequired,
  currencyCode: PropTypes.string,
  paymentMethod: PropTypes.string,
  baseClass: PropTypes.string.isRequired,
  isForecast: PropTypes.bool.isRequired
};

OrderLineItemPF.defaultProps = {
  currencyCode: null,
  paymentMethod: ''
};

export default OrderLineItemPF;
